import React, { useState } from "react";
import Navbar from "../components/navbar/Navbar";
import Sidebar from "../components/sidebar/Sidebar";
import { Outlet } from "react-router-dom";
const Layout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen sticky top-0 z-50 flex justify-end ">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="ml-[260px] flex-1 flex flex-col h-screen overflow-hidden">
        <Navbar isSidebarOpen={isSidebarOpen} />
        <div className="flex-1 overflow-auto outlet_container">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
